import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.99815 12.6484C6.40398 12.6484 3.33398 13.2151 3.33398 15.4818C3.33398 17.7493 6.38482 18.3359 9.99815 18.3359C13.5923 18.3359 16.6623 17.7701 16.6623 15.5026C16.6623 13.2351 13.6123 12.6484 9.99815 12.6484Z" }, null, -1),
    _createElementVNode("path", { d: "M9.99789 10.488C12.4462 10.488 14.4079 8.52547 14.4079 6.07797C14.4079 3.63047 12.4462 1.66797 9.99789 1.66797C7.55039 1.66797 5.58789 3.63047 5.58789 6.07797C5.58789 8.52547 7.55039 10.488 9.99789 10.488Z" }, null, -1)
  ]))]))
}
export default { render: render }